import { axiosInstance,axiosRequestWithAuth } from './../constants/server.constant';
import { getFullRegionDetail } from '../utility/utility';

export const FirewallService = {
    getFirewallList,
    getFirewallLimit,
    createFirewall,
    editFirewallById,
    getFirewallDetailsByid,
    deleteFirewallByid,
    addFirewallRules,
    deleteFirewallRulesByRulesId,
    getAllFirewallDetails
};

function getUserId() {
    return localStorage.getItem('userId');
}

async function getFirewallList() {
    return await axiosInstance.get('/security_group/'+getUserId(),axiosRequestWithAuth)
        .then(firewalls => {
            let data = firewalls.data
            if(data === undefined) {
                return firewalls
            }
            let fullRegionList = JSON.parse(localStorage.getItem('fullRegionList'));
            data.forEach(item=>{
                item.fullRegion= getFullRegionDetail(fullRegionList,item.region_name)
            });
            return data
        }).catch(function (error) {
            return []
        });
}

async function getFirewallLimit() {
    return await axiosInstance.get('/security_group/limit/'+getUserId(),axiosRequestWithAuth)
        .then(firewalls => {
            return firewalls.data
        }).catch(function (error) {
            return []
        });
}

async function createFirewall(requestBody,regionUrl) {
    return await axiosInstance.post('/security_group/'+getUserId()+'?regionUrl='+regionUrl, requestBody , axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            return []
        });
}

async function editFirewallById(id,requestBody,regionUrl) {
    return await axiosInstance.put('/security_group/'+id+'/'+getUserId()+'?regionUrl='+regionUrl, requestBody, axiosRequestWithAuth)
        .then(data => {
            return true;
        }).catch(function (error) {
            return false
        });
}

async function deleteFirewallByid(id,regionUrl) {
    return axiosInstance.delete('/security_group/'+id+'/'+getUserId()+'?regionUrl='+regionUrl, axiosRequestWithAuth)
        .then(data => {
            return true;
        }).catch(function (error) {
            return false;
        });
}

async function getFirewallDetailsByid(id,regionUrl) {
    return await axiosInstance.get('/security_group/' + id+'/'+getUserId()+'?regionUrl='+regionUrl, axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            return false;
        });
}

async function addFirewallRules(regionUrl,requestBody) {
    return await axiosInstance.post('/security_group/rules/'+ getUserId() +'?regionUrl='+regionUrl, requestBody, axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            return false;
        });
}

async function deleteFirewallRulesByRulesId(regionUrl,requestBody) {
    var reqHeaders = axiosRequestWithAuth; 
    reqHeaders.data = requestBody;
    return await axiosInstance.delete('/security_group/rules/'+ getUserId() +'?regionUrl='+regionUrl, reqHeaders)
        .then(regions => {
            reqHeaders.data = undefined;
            return true;
        }).catch(function (error) {
            reqHeaders.data = undefined;
            return false;
        });
}

async function getAllFirewallDetails(){
    return await axiosInstance.get('/security_group/'+getUserId(), axiosRequestWithAuth)
        .then(firewallDetails => {
            return firewallDetails.data;
        }).catch(function (error) {
            return false;
        });
}

export default FirewallService;